/**
 * Initialize YouTube video placeholders that load the actual video on click
 * @param {string} selector - CSS selector for video placeholders (default: '.youtube-placeholder')
 */
const initYouTubePlaceholders = (selector = '.youtube-placeholder') => {
  document.querySelectorAll(selector).forEach(placeholder => {
    placeholder.addEventListener('click', () => {
      const videoId = placeholder.dataset.id;
      placeholder.innerHTML = `
        <iframe
          src="https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1"
          title="YouTube video"
          frameborder="0"
          loading="lazy"
          width="100%"
          allow="autoplay; encrypted-media"
          allowfullscreen
        ></iframe>`;
    });
  });
};

export { initYouTubePlaceholders };
